import React from "react";

import { AvatarOnline, AvatarOffline } from "../Avatar";

const USER_STATUS = {
  ONLINE: "online",
  OFFLINE: "offline",
};

const USER_STATUS_MAP = {
  [USER_STATUS.ONLINE]: {
    font: "has-text-primary",
    icon: AvatarOnline,
    label: USER_STATUS.ONLINE,
  },
  [USER_STATUS.OFFLINE]: {
    font: "has-text-grey-light",
    icon: AvatarOffline,
    label: USER_STATUS.OFFLINE,
  },
  [undefined]: {
    font: "has-text-grey-light",
    icon: AvatarOffline,
    label: USER_STATUS.OFFLINE,
  },
};

// `activity` is this user's latest check-in today, from UserList's listener.
const UserStatus = ({ user, activity }) => {
  const { firstName, lastName } = user;

  const style = USER_STATUS_MAP[activity?.status];

  return (
    <div className="column columns is-gapless" style={{ marginBottom: "0", maxWidth: "100px" }}>
      <div className="column">{style?.icon()}</div>
      <div className="column is-three-quarters">
        <div style={{ fontSize: "12px" }}>{`${firstName} ${lastName?.[0]?.toUpperCase()}`}</div>
        <div className={`${style?.font}`} style={{ fontSize: "10px" }}>
          {style?.label}
        </div>
      </div>
    </div>
  );
};

export default UserStatus;
